var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeled-check-box"},[_c('label',[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event)}}}),_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }